import { LocalTransportPricing } from '../../lib/types/models/local-transport-pricing/local-transport-pricing'
import { LocalTransportPricingInput } from '../../lib/types/models/local-transport-pricing/local-transport-pricing-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateCenterLocalTransport(input: UpdateInput<LocalTransportPricingInput>) {
  const { id, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterLocalTransport.url, { id }))
    .patch<LocalTransportPricing>({ ...data })
}
